import React, { Fragment } from 'react'
import { Form, InputGroup, Table } from 'react-bootstrap'
import product1 from '../../Assets/Images/subs.png'
import { useLocation } from 'react-router-dom'

const SubsOrderSummary = () => {
    return (
        <Fragment>
            <div className="row ">
                <div className="col-lg-12">
                    <div className="bg-light p-3 card border-0">

                        <div className="card-body">

                            <p className='mb-0  s-19 '>
                                Order Summary
                            </p>


                            <hr />
                            <div className="row align-items-center py-2">
                                <div className="col-auto">
                                    <img src={product1} width={"66.71px"} height={"50.98px"} className='rounded-2' alt="" />
                                </div>

                                <div className="col ps-0">
                                    <div className="row " >
                                        <div className="col">
                                            <h5 className='s-17 mb-0'>
                                                Yearly Subscription
                                            </h5>
                                        </div>
                                        <div className="col-auto">
                                            <h5 className='s-17 fw-500 mb-0'>
                                                $80.0
                                            </h5>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-auto">
                                            <p className='s-16 text-muted mb-0'>
                                                12 month
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            <hr />

                            <div className="row py-2">
                                <div className="col">
                                    <p className='mb-0 16px'>
                                        Sub Total
                                    </p>
                                </div>

                                <div className="col-auto">
                                    <p className='mb-0 16px'>
                                        $240.0
                                    </p>
                                </div>
                            </div>

                            <hr />

                            <div className="row py-2">
                                <div className="col">
                                    <p className='16px mb-0'>
                                        Total
                                    </p>
                                </div>

                                <div className="col-auto">
                                    <p className='16px mb-0'>
                                        $201.0
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            </div>
        </Fragment>
    )
}

export default SubsOrderSummary